<template>
  <div class="living-item" :style="`background-image: url(${isBilling ? item.cover : item.liveListImg})`">
    <div class="item-content">
      <div v-if="!isActivity" :class="isBilling ? 'living-box' : 'living-half-box'">
        <!--广告位直播有两种状态：直播中，预告-->
        <notice-tag v-if="liveStatus === 0" :title="title" :content="content"></notice-tag>
<!--        <notice-tag v-else-if="liveStatus === 2" :title="title" :content="content" bgImage="linear-gradient(131deg, #A2B3CD 0%, #6A87B2 97%)"></notice-tag>-->
        <notice-tag v-else :hasPoint="true" :title="title" :content="content" bgImage="linear-gradient(-53deg, #FB5757 0%, #FF745B 100%)"></notice-tag>

        <img
          class="icon-nav"
          v-if="item.showType"
          :src="item.showType === 1 ?
            require('../../assets/images/icon-video.png') :
            require('../../assets/images/icon-broadcast.png')
          "
          alt="壹心理直播"
        />
      </div>
      <div :class="isActivity ? 'living-activity' : 'living-default'" class="living-left">
        <info-con :is-activity="isActivity" :img-src="imgSrc" :title="infoTitle" :subheading="subheading"></info-con>
      </div>
      <like-canvas v-if="!isActivity && (liveStatus === 1 ||liveStatus === 3)" ref="like" :class="isBilling ? 'like-container' : 'like-half-container'" v-slot:default :sum="item.likeNum" :keep-like="true">
        <div class="img-box">
          <div v-if="item.likeNum" class="num-box">
            <div class="num">
              <span>{{ item.likeNum | millionNum }}</span>
            </div>
          </div>
          <img class="like-img" src="../../assets/images/like.png" alt="壹心理直播-点赞">
        </div>
      </like-canvas>
    </div>
  </div>
</template>

<script>
  import LikeCanvas from '@/components/LikeCanvas'
  import NoticeTag from 'components/NoticeTag'
  import InfoCon from 'components/InfoCon'

  export default {
    name: "Living",
    components: {
      LikeCanvas,
      NoticeTag,
      InfoCon
    },
    props: {
      isBilling: { // 广告位样式和普通直播样式不同
        type: Boolean,
        default: false
      },
      item: {
        type: Object,
        default: ()=>{}
      }
    },
    computed: {
      title() {
        return this.liveStatus === 0 ? '预告' : '直播中'
      },
      liveStatus() {
        if (this.isBilling) {
          return this.item.liveStatus
        } else {
          return 1
        }
      },
      content() {
        const num = this.isBilling ? this.item.viewSum : this.item.watchNum
        if (!num) return ''
        if (num < 10000) {
          return `${num}观看`
        } else {
          return `${formatDecimal(num/10000, 1)}万观看`
        }
      },
      isActivity() { // 广告位是活动or直播
        if (this.isBilling) {
          return !this.item.liveId
        }
        return false
      },
      imgSrc() {
        if (!this.isActivity) {
          return this.item.channelAvatar
        }
        return this.item.channelPortrait
      },
      infoTitle() {
        if (!this.isActivity) {
          return this.isBilling ? this.item.userName : this.item.channelName
        }
        return ''
      },
      subheading() {
        /*非活动即付费直播(课程)*/
        if (this.isActivity) {
          return this.item.activityTitle || ''
        }
        return this.item.liveTitle || ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins.scss";

  .living-item {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    .item-content {
      position: absolute;
      height: 100%;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;

    }
  }

  .living-left {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .living-activity {
    /deep/ .info-box {
      width: 96%;
    }
  }

  .living-default {
    /deep/ .info-box {
      width: 75%;
    }
  }

  .living-half-box,
  .living-box {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-size: 26px;
    text-align: center;

    border-radius: 10px;
    overflow: hidden;
    color: #fff;
    .icon-nav {
      display: block;
      width: 26px;
      height: 26px;
    }
  }

  .living-box {
    left: 22px;
    right: 22px;
    top: 22px;
  }

  .living-half-box {
    left: 16px;
    right: 16px;
    top: 16px;
  }

  .like-container,
  .like-half-container{
    position: absolute;
    right: -20px;
    bottom: 20px;

    .img-box {
      position: relative;

      .num-box {
        position: absolute;
        top: -34px;
        left: 50%;
        transform: translateX(-50%);
      }

      .num {
        display: flex;
        justify-content: center;
        align-items: center;

        height: 44px;
        transform: scale(.5);
        padding: 2px 20px;
        background: #FA775F;
        font-size: 36px;
        color: #fff;
        border-radius: 24px;
        word-break: keep-all;
      }

      .like-img {
        width: 40px;
      }
    }
  }

  .like-half-container {
    right: -60px;
    bottom: -16px;
    transform: scale(.8);
  }
</style>
